<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "AppMain",
  
})
</script>
<template>
  <section :class="[isFullScreen ? 'app-main-full': 'app-main', classObj]">
    <router-view v-slot="{ Component, route }">
      <!-- <transition v-if="!route.meta.noCache" :enter-active-class="animante" mode="out-in"> -->
      <transition v-if="!route.meta.noCache" mode="out-in">
        <keep-alive v-if="!route.meta.noCache" :include="tagsViewStore.cachedViews">
          <component :is="Component" v-if="!route.meta.link" :key="route.path" />
        </keep-alive>
      </transition>
      <!-- <transition v-if="route.meta.noCache" :enter-active-class="animante" mode="out-in"> -->
      <transition v-if="route.meta.noCache" mode="out-in">
        <component :is="Component" v-if="!route.meta.link && route.meta.noCache" :key="route.path" />
      </transition>
    </router-view>
    <iframe-toggle />
  </section>
</template>

<script setup name="AppMain" lang="ts">
import useSettingsStore from '@/store/modules/settings';
import useTagsViewStore from '@/store/modules/tagsView';
import useAppStore from '@/store/modules/app';
import IframeToggle from './IframeToggle/index.vue';

defineProps({
  isFullScreen: {
    type: Boolean,
    default: false
  }
})
const { proxy } = getCurrentInstance() as ComponentInternalInstance;
const tagsViewStore = useTagsViewStore();
const sidebar = computed(() => useAppStore().sidebar);
const classObj = computed(() => ({
  hideSidebar: !sidebar.value.opened,
  openSidebar: sidebar.value.opened
}));

// 随机动画集合
const animante = ref<string>('');
const animationEnable = ref(useSettingsStore().animationEnable);
watch(
  () => useSettingsStore().animationEnable,
  (val: boolean) => {
    animationEnable.value = val;
    if (val) {
      animante.value = proxy?.animate.animateList[Math.round(Math.random() * proxy?.animate.animateList.length)] as string;
    } else {
      animante.value = proxy?.animate.defaultAnimate as string;
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/mixin.scss';
@import '@/assets/styles/variables.module.scss';

.app-main {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: calc(100vw - #{$base-sidebar-width});
  position: relative;
  overflow: auto;
  background-color: #eee;
}
.app-main-full {
  /* 50= navbar  50  */
  min-height: calc(100vh - 50px);
  width: 100vw;
  position: relative;
  overflow: auto;
  background-color: #eee;
}


.hideSidebar .app-main {
  width: calc(100vw - 54px);
}

.fixed-header + .app-main {
  padding-top: 50px;
}

.hasTagsView {
  .app-main {
    /* 84 = navbar + tags-view = 50 + 34 */
    min-height: calc(100vh - 50px);
  }

  .fixed-header + .app-main {
    padding-top: 84px;
  }
}
</style>
<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 6px;
  }
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c0c0c0;
  border-radius: 3px;
}
</style>
